import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import Home from "./Home";
// import Conditions from "./Conditions";
import Privacy from "./Privacy";
import Use from "./Use";
// import TwoButtonPage from "./TwoButtonCalender";
import RedirectPage from "./OnelinkClickCalender";

export default () => (
    <BrowserRouter>
        <Switch>
            <Route path="/" exact render={props => <Home {...props} />} />
            {/* <Route path="/terms-conditions" exact render={props => <Conditions {...props} />} /> */}
            <Route path="/privacy-policy" exact render={props => <Privacy {...props} />} />
            <Route path="/terms-use" exact render={props => <Use {...props} />} />
            <Route path='/download' component={() => { window.location = 'http://onelink.to/calendar-19'; return null;} }/>
            {/* <Route path="/two-button-install" exact render={props => <TwoButtonPage {...props} />} /> */}
            {/* <Route path="/download" exact render={props => <RedirectPage {...props} />} /> */}
        </Switch>
    </BrowserRouter>
)